const idSearchPattern = /^\s*#\S+(?:\s+#\S+)*\s*$/u;
const idTokenPattern = /#(\S+)/gu;

/**
 * Returns the ids from a `#id1 #id2` search, or undefined when the text is
 * not an id search.
 */
export const parseIdSearch = (text: string): string[] | undefined => {
  if (!idSearchPattern.test(text)) return undefined;
  return [...text.matchAll(idTokenPattern)].map((m) => m[1]);
};

/** Only all-digit ids can also be internal ids. */
export const toInternalIds = (ids: string[]): number[] =>
  ids
    .filter((id) => /^\d+$/.test(id))
    .map(Number)
    .filter(Number.isSafeInteger);
